export enum CalculationType {
  Monthly = 'Per month',
  Yearly = 'Per year',
  Hourly = 'Per hour',
}
